module.exports = __webpack_public_path__ + "static/media/pic_huodon3.53e636d0.png";